// composables/useAuthGuard.ts
export const useAuthGuard = async () => {
  const { loggedIn, fetch } = useUserSession()
  const router = useRouter()
  const route = useRoute()

  // Ensure auth state is current
  //await fetch()

  // checks auth state if user accesses a protected page directly
  // without going through the login flow, eg
  // by typing the URL in the browser

  if (!loggedIn.value && !route.path.startsWith('/auth')) {
    await router.push("/auth/login")
    return false
  }

  return true
}
